function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "IMG_Close_Icon",
  transform: "translate(-1040.711 -97.211)"
}, /*#__PURE__*/React.createElement("line", {
  id: "Linie_37",
  "data-name": "Linie 37",
  y2: 45.255,
  transform: "translate(1042.833 99.333) rotate(-45)",
  fill: "none",
  stroke: "#ffe666",
  strokeLinecap: "round",
  strokeWidth: 3
}), /*#__PURE__*/React.createElement("line", {
  id: "Linie_38",
  "data-name": "Linie 38",
  y2: 45.255,
  transform: "translate(1074.833 99.333) rotate(45)",
  fill: "none",
  stroke: "#ffe666",
  strokeLinecap: "round",
  strokeWidth: 3
}));

function SvgImgCloseIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 36.243,
    height: 36.243,
    viewBox: "0 0 36.243 36.243",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgImgCloseIcon);
export default __webpack_public_path__ + "static/media/IMG_Close_Icon.ba5466c6abdff25db24b08fa90394257.svg";
export { ForwardRef as ReactComponent };